"use client";

import type { MouseEvent, ReactNode } from "react";
import { BOOKING_EMBED_URL, BOOKING_ENABLED, BOOKING_HREF, openBooking } from "@/lib/booking";

type BookCallProps = {
  className?: string;
  children: ReactNode;
  /** Runs before the booking opens, e.g. closing the mobile menu behind it. */
  onActivate?: () => void;
};

/**
 * Every "book a call" CTA on the site, so the booking route is decided in one place
 * (lib/booking.ts). A plain click opens the Google booking dialog over the page; modified
 * clicks keep normal link behaviour. A booking link Google will not let us frame opens in
 * a new tab, and with no link set the anchor is the pre-filled email.
 */
export const BookCall = ({ className, children, onActivate }: BookCallProps) => {
  const newTab = BOOKING_ENABLED && !BOOKING_EMBED_URL;
  return (
    <a
      href={BOOKING_HREF}
      className={className}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noopener noreferrer" : undefined}
      aria-haspopup={BOOKING_EMBED_URL ? "dialog" : undefined}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        onActivate?.();
        if (!BOOKING_EMBED_URL) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openBooking();
      }}
    >
      {children}
    </a>
  );
};
